import { render } from "./ScheduleView.vue?vue&type=template&id=72af66b3"
import script from "./ScheduleView.vue?vue&type=script&lang=js"
export * from "./ScheduleView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__